module.exports = __webpack_public_path__ + "img/sankaku_48_red.57628e23.png";